module.exports = __webpack_public_path__ + "static/media/wreath.c1c55bbc.svg";